import { getApi } from "./api_instance";

export const unSeenNotificationCount = async (logout) => {
  try {
    return await getApi({
      apiUrl: "/admin/projects/api/notification/count",
      sendToken: true,
      logout
    });
  } catch (error) {
    throw error;
  }
};
